export default "__VITE_ASSET__nQXlZr1___"